<template>
  <b-modal
      ref="modal"
      :title="title"
      :ok-title="okText"
      :cancel-title="cancelText"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      @hide="cancelar">
    <div v-html="message"></div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button v-if="showCancel" size="lg" variant="secondary" @click="cancelar" class="mr-auto">{{cancelText}}</b-button>
      <b-button size="lg" variant="primary" @click="confirmar">{{okText}}</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      message: '',
      title: 'Confirmar',
      okText: 'OK',
      cancelText: 'Cancelar',
      showCancel: true,
      resolve: null
    }
  },
  methods: {
    open(message, options = {}) {
      this.message = message;
      this.title = options.title ? options.title : 'Confirmar';
      this.okText = options.okText ? options.okText : 'OK';
      this.cancelText = options.cancelText ? options.cancelText : 'Cancelar';
      this.showCancel = options.showCancel !== false;
      this.$refs.modal.show();
      return new Promise((resolve) => {
        this.resolve = resolve;
      }).finally(() => {
        this.$refs.modal.hide();
      });
    },
    confirmar() {
      this.resolve(true);
    },
    cancelar() {
      this.resolve(false);
    }
  }
}
</script>
<style scoped>
::v-deep .modal-content{
  border-radius: 22px;
  box-shadow: 0px 0px 15px 0 #00000050;
  border: none;
}
.btn{
  border: none;
  border-radius: 40px;
  font: normal normal 300 18px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #FFFFFF;
  padding: 6px 20px;
  height: 49px;
}
.btn-primary:hover{
  box-shadow: inset 0px 0px 100px #00000040;
}

.btn-secondary{
  display: inline-block !important;
  color: #FFFFFF;
}

.btn-secondary:hover{
  background-color: var(--secondary-color);
}
</style>
